import script from "./CartPageXL.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPageXL.vue?vue&type=script&setup=true&lang=js"

import "./CartPageXL.vue?vue&type=style&index=0&id=0f83b952&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f83b952"]])

export default __exports__